// extracted by mini-css-extract-plugin
export var cardHeader = "_t1-0";
export var reorderHandle = "_t1-3";
export var titleArea = "_t1-1";
export var titleAreaWithHandle = "_t1-2";